module.exports = "/shifts/modal-choose-applicant-e51fe9.html";